import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    BehaviorSubject,
    catchError,
    map,
    Observable,
    of,
    ReplaySubject,
    switchMap,
    take,
    tap,
    throwError,
} from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AppstyleService {

    private _backgroudcolor: BehaviorSubject<string > = new BehaviorSubject<string>('bg-white');

    constructor() {}


    /**
     * Getter for Atencion
     */

    set backgroudcolor(color: string) {
        this._backgroudcolor.next(color);
    }

    get backgroudcolor$(): Observable<string> {
        return this._backgroudcolor.asObservable();
    }
}
